import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Badge, Button } from "@vimos/ui";
import { supabase } from "../../lib/supabase";
import type { BlogPost } from "@vimos/api-client";

async function fetchPosts(): Promise<BlogPost[]> {
  const { data, error } = await supabase
    .from("blog_posts")
    .select("*")
    .order("created_at", { ascending: false });
  if (error) throw error;
  return data ?? [];
}

export function BlogListPage() {
  const { data: posts, isLoading, error } = useQuery({ queryKey: ["blog_posts"], queryFn: fetchPosts });

  return (
    <div>
      <div className="flex items-center justify-between">
        <h1 className="font-display text-ink text-2xl font-bold">Blog</h1>
        <Link to="/blog/nuevo">
          <Button>Nueva publicación</Button>
        </Link>
      </div>

      {isLoading && <p className="text-mist mt-6">Cargando publicaciones…</p>}
      {error && <p className="mt-6 text-red-600">No pudimos cargar las publicaciones.</p>}

      {posts && posts.length === 0 && (
        <p className="text-mist mt-6">Todavía no hay publicaciones. Crea la primera.</p>
      )}

      <ul className="divide-sand/40 border-sand/40 bg-paper mt-6 divide-y rounded-lg border">
        {posts?.map((post) => (
          <li key={post.id} className="flex items-center justify-between px-4 py-3">
            <div>
              <Link to={`/blog/${post.id}`} className="font-body text-ink hover:text-signal font-medium">
                {post.title}
              </Link>
              <p className="text-mist text-sm">{post.excerpt}</p>
            </div>
            <Badge tone={post.is_published ? "market" : "neutral"}>
              {post.is_published ? "Publicado" : "Borrador"}
            </Badge>
          </li>
        ))}
      </ul>
    </div>
  );
}
